export const CUSTOMER_BANKING_GET_DATA_ENDPOINT = "/api/:customerSlug/banking/data";
export const CUSTOMER_BANKING_APPLY_ENDPOINT = "/api/:customerSlug/banking/apply";
export const CUSTOMER_BANKING_MFA_SETUP_COMPLETE_ENDPOINT = "/api/:customerSlug/banking/mfa-setup-complete";
export const CUSTOMER_BANKING_REGISTER_INTEREST_ENDPOINT = "/api/:customerSlug/banking/submit-waitlist";
export const CUSTOMER_BANKING_GET_REGISTER_INTEREST_ENDPOINT = "/api/:customerSlug/banking/has-waitlist";
export const CUSTOMER_BANKING_REGISTER_INTEREST_KEY = "registerBankingInterest";

// Maximum number of bank accounts to show in navigation before displaying "See more" link
export const MAX_VISIBLE_ACCOUNTS = 4;
